import { useSelector } from 'react-redux';
import SVG from 'react-inlinesvg';
import Tooltip, { TooltipDirection, TooltipTheme } from 'lib/Tooltip';
import errorSvg from 'assets/icons/error.svg';
import { getCampaignIdsWithOOCFrames } from 'store/pages/directSalesOOC/selectors';

const OOCRenderer: React.FC<{ campaignId?: string }> = ({ campaignId }) => {
  const campaignIdsWithOOCFrames = useSelector(getCampaignIdsWithOOCFrames);

  if (!campaignId || !campaignIdsWithOOCFrames[campaignId]) return null;

  return (
    <Tooltip
      direction={TooltipDirection.RIGHT}
      theme={TooltipTheme.DARK}
      tooltip="Action required. This campaign includes out of charge frames"
    >
      <div>
        <SVG src={errorSvg} className="inline-block text-center leading-tight align-middle text-tertiary w-5 h-5" />
      </div>
    </Tooltip>
  );
};
export default OOCRenderer;
